"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleWithoutDestroy = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
exports.ToggleWithoutDestroy = (0, react_1.memo)(function (_a) {
    var condition = _a.condition, childTrue = _a.childTrue, childFalse = _a.childFalse, style = _a.style;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: condition ? style : { display: 'none' } }, childTrue),
        react_1.default.createElement("div", { style: condition ? { display: 'none' } : style }, childFalse)));
});
exports.ToggleWithoutDestroy.displayName = 'ToggleWithoutDestroy';
